/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type XeroSignupContainer_viewer$ref: FragmentReference;
declare export opaque type XeroSignupContainer_viewer$fragmentType: XeroSignupContainer_viewer$ref;
export type XeroSignupContainer_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +$refType: XeroSignupContainer_viewer$ref,
|};
export type XeroSignupContainer_viewer$data = XeroSignupContainer_viewer;
export type XeroSignupContainer_viewer$key = {
  +$data?: XeroSignupContainer_viewer$data,
  +$fragmentRefs: XeroSignupContainer_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "XeroSignupContainer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '16a44da6d34762482e609e341a010130';

module.exports = node;
